<template>
	<div class="page">
		<van-icon name="arrow-left" class="return" size="28" @click="goBack" />
		<div class="logo">
			<img src="../assets/images/logo/logo2.png" alt="" />
		</div>
		<div class="theme-logo"></div>
		<div class="sub-logo"></div>
		<div class="info">
			<div class="sub-title">用餐安排</div>
			<div class="map">
				<img
					src="../assets/images/service/2.jpg"
					alt=""
					class="responsive-map"
				/>
				<img
					src="../assets/images/service/1.png"
					alt=""
					class="responsive-map"
				/>
			</div>
			<div class="text">用餐餐厅: 武汉富力万达嘉华酒店（三楼大宴会厅）</div>
            <!-- <div class="text">用餐形式: 自助午餐(11:00-13:00 )</div> -->
        </div>
	</div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const goBack = () => {
	router.back();
};
</script>

<style scoped>
.page {
	width: 100vw;
	min-height: 100vh; /* 使用 min-height 代替 height */
	background: url("../assets/bg/718.jpg") 100% 100% no-repeat;
	background-size: cover;
	background-attachment: fixed; /* 固定背景 */
}

.return {
	color: #fff;
	padding: 10px;
	border-radius: 5px;
	cursor: pointer;
}

.logo img {
	width: 40%;
	height: auto;
	display: block;
    margin: auto;
	padding: 20px 0;
	/* margin-left: 10%; */
}

.sub-logo {
	width: 90%;
	height: 30px;
	background: url("../assets/images/logo/text.png") no-repeat center center;
	background-size: contain;
	margin: auto;
}

.theme-logo {
	width: 80%;
	height: 60px;
background: url("../assets/images/logo/aiTitle.png") no-repeat center center;
	background-size: contain;
	margin: auto;
}

.info {
	width: 82%;
	margin: auto;
	border-radius: 15px;
	margin-top: 20px;
	padding: 20px 10px;
	/* background-color: rgb(2 174 250 / 20%); */
      background: linear-gradient(180deg, #00b4ff, rgba(0, 123, 255, 0.3));
}
.text {
	/* color: #ffffff; */
	text-align: center;
	margin: 5px 0;
	font-size: 14px;
    font-weight: bold;
}

.sub-title {
	font-size: 18px;
    font-weight: bold;
    color: #fff;
    text-align: center;
}

.desc {
	color: #ffffff;
    text-align: center;
    margin: 3px 0;
    font-size: 13px;
}

.responsive-map {
	width: 100%;
	height: auto;
	border-radius: 15px;
	margin-top: 10px;
}
.qrCode {
    display: flex;
    margin-top: 10px;
}
.qrCode img {
    width: 80px;
    height: auto;
    margin: 0 auto;
}
.apply {
	width: 150px;
	height: 40px;
	/* height: auto; */
	background-image: url("../assets/images/apply.png"); /* 替换为你的背景图片路径 */
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: auto;
	margin-top: 15px;
	color: #071beb;
	font-weight: bold;
}
</style>
